module.exports = __webpack_public_path__ + "static/Q2Answer4_Noonelaughing_AlexLauzon-3dc6b34202b9867ca6537eacbb422d26.jpg";